import { getServerTime } from '../../../utils/wz.v2'

export default {
    update (state) {
        state._now = getServerTime()
    }
}
